<template>
  <div v-if="visible" class="wrapper" @touchmove.prevent>
    <div class="content">
      <div class="top">确认账号</div>
      <div class="mid">
        <div class="account_field">
          <span class="account_label">当前账号：</span>
          <span class="account_value">{{ account || '-' }}</span>
        </div>
      </div>
      <div class="footer">
        <div
          class="dialog_btn change_account"
          :class="{ disabled: submitLoading }"
          @click="onChangeAccount"
        >
          更换账号
        </div>
        <div
          class="dialog_btn submit"
          :class="{ disabled: submitLoading }"
          @click="onConfirm"
        >
          {{ submitLoading ? '绑定中...' : '确认绑定' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityLandingConfirmAccountDialog',
  props: {
    submitLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      userInfo: {},
    };
  },
  computed: {
    account() {
      return (this.userInfo && this.userInfo.game_account) || '';
    },
  },
  methods: {
    open(userInfo = {}) {
      this.userInfo = userInfo || {};
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    onChangeAccount() {
      if (this.submitLoading) return;
      this.close();
      this.$emit('change-account');
    },
    onConfirm() {
      if (this.submitLoading) return;
      this.$emit('confirm', this.userInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 110;
  .content {
    width: 312px;
    height: 196px;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    margin: 0 auto;
    position: relative;
    .top {
      width: 100%;
      height: 38px;
      text-align: center;
      line-height: 38px;
      color: #fff;
      background: #fe4f4a;
      font-size: 17px;
      font-weight: 700;
    }
    .mid {
      width: 100%;
      padding: 0 20px;
      margin-top: 30px;
    }
    .account_field {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 44px;
      border-bottom: 1px solid #ebedf0;
    }
    .account_label {
      flex: none;
      color: #646566;
      font-size: 14px;
      line-height: 24px;
    }
    .account_value {
      min-width: 0;
      max-width: 180px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #fe4f4a;
      font-size: 14px;
      line-height: 24px;
    }
    .footer {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 22px;
      margin-top: 24px;
    }
    .dialog_btn {
      width: 121.5px;
      height: 39px;
      border-radius: 39px;
      line-height: 39px;
      text-align: center;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      font-size: 16px;
      box-sizing: border-box;
      &.disabled {
        opacity: 0.65;
      }
    }
    .change_account {
      color: #fe4f4a;
      background: #fff;
      border: 1px solid #fe4f4a;
    }
    .submit {
      color: #fff;
      background: #fe4f4a;
    }
  }
}
</style>
